import produce from "immer";
import reducerUtils from "../../../../store/reducerUtils";

const KBaseActions = {
  LIST_LOADED: "KBASE_LIST_LOADED",
  LIST_COUNTER_INC: "KBASE_LIST_COUNTER_INC",
  KBASE_LOADED: "KBASE_LOADED",
};

const initialState = {
  data: {
    list: null,
    listCounter: 0,
    kbase: null,
  },
};

export const kbaseSelectors = {
  getList: (state) => state.kbase.data.list,
  getListCounter: (state) => state.kbase.data.listCounter,
  getKBase: (state) => state.kbase.data.kbase,
};

const onListLoaded = produce((draft, action) => {
  draft.data.list = action.list;
});

const onListCounterInc = produce((draft) => {
  draft.data.listCounter++;
});

const onKBaseLoaded = produce((draft, action) => {
  draft.data.kbase = action.kbase;
});

const handlers = {
  [KBaseActions.LIST_LOADED]: onListLoaded,
  [KBaseActions.LIST_COUNTER_INC]: onListCounterInc,
  [KBaseActions.KBASE_LOADED]: onKBaseLoaded,
};

const kbaseReducer = reducerUtils.createReducer(initialState, handlers);

export default kbaseReducer;
export { KBaseActions };
